import { DeletedFilled, EditIcon } from 'assets/images/svg';
import { useManagePermittedRoles } from 'library/hooks';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectFloorsByFloorID } from 'reduxStore/floors/selectors';
import { DeleteFloorModal, UpdateFloorModal } from 'zComponents/molecules';
import { Button, Flex, Tooltip, Typography } from 'zui/Antd';

const { Title } = Typography;

const ViewFloorHeader = ({ floorID }) => {
	//Local state
	const [openUpdateModal, setOpenUpdateModal] = useState(false);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);

	const floor = useSelector((state) => selectFloorsByFloorID(state, floorID));

	//Determine if is permitted to edit floors
	const isPermittedUpdateFloor = useManagePermittedRoles('updateFloor', {
		101: [floor?.orgID],
		103: [floor?.siteID],
		104: [floor?.floorID]
	});

	//Determine if is permitted to  delete floors
	const isPermittedDeleteFloor = useManagePermittedRoles('deleteFloor', {
		101: [floor?.orgID],
		103: [floor?.siteID],
		104: [floor?.floorID]
	});

	const permissionDeniedMessage = "You don't have permission to perform this action.";

	//Handle stop propagation for buttons
	const handleStopPropagation = (e) => {
		e.stopPropagation();
	};

	return (
		<Flex justify='space-between' align='center'>
			<Title level={5} style={{ margin: 0 }}>
				{floor?.name || 'Unknown Floor'}
			</Title>
			<Flex gap={8} onClick={handleStopPropagation}>
				<UpdateFloorModal open={openUpdateModal} setOpen={setOpenUpdateModal} floorID={floor.floorID}>
					<Tooltip title={!isPermittedUpdateFloor ? permissionDeniedMessage : 'Edit Floor'}>
						<Button
							type='text'
							size='small'
							icon={<EditIcon color='currentColor' />}
							disabled={!isPermittedUpdateFloor}
							onClick={(e) => setOpenUpdateModal(true)}
						/>
					</Tooltip>
				</UpdateFloorModal>
				<DeleteFloorModal open={openDeleteModal} setOpen={setOpenDeleteModal} floorID={floor.floorID}>
					<Tooltip title={!isPermittedDeleteFloor ? permissionDeniedMessage : 'Delete Floor'}>
						<Button
							type='text'
							size='small'
							icon={<DeletedFilled width={16} height={16} color='currentColor' />}
							disabled={!isPermittedDeleteFloor}
							onClick={(e) => setOpenDeleteModal(true)}
						/>
					</Tooltip>
				</DeleteFloorModal>
			</Flex>
		</Flex>
	);
};

export default ViewFloorHeader;
